var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconNoResult(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 200,
    viewBox: "0 0 400 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M348 96V66c0-1.66-1.34-3-3-3h-39c-1.66 0-3 1.34-3 3v16c0 1.66-1.34 3-3 3h-28c-1.66 0-3-1.34-3-3v-9c0-1.66-1.34-3-3-3h-42c-1.66 0-3 1.34-3 3v79c0 1.66 1.34 3 3 3h155c1.66 0 3-1.34 3-3v-50c0-1.66-1.34-3-3-3h-28c-1.66 0-3-1.34-3-3z",
    fill: "url(#icon_no_result_svg__paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M133 49h-27c-1.66 0-3 1.34-3 3v34c0 1.66-1.34 3-3 3H73c-1.66 0-3-1.34-3-3V72.32c0-1.66-1.34-3-3-3H21c-1.66 0-3 1.34-3 3V152c0 1.66 1.34 3 3 3h143.93c1.66 0 3-1.34 3-3V83c0-1.66-1.34-3-3-3H139c-1.66 0-3-1.34-3-3V52c0-1.66-1.34-3-3-3z",
    fill: "url(#icon_no_result_svg__paint1_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.36 43.65v2.92M40.36 55.73v2.92M47.86 51.15h-2.52M35.38 51.15h-2.52M375.36 62.65v2.92M375.36 74.73v2.92M382.86 70.15h-2.52M370.38 70.15h-2.52M119.36 89.65v2.92M119.36 101.73v2.92M126.86 97.15h-2.53M114.38 97.15h-2.53",
    stroke: "#DDD",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M75.86 134.15a3.5 3.5 0 100-7 3.5 3.5 0 000 7zM336.86 113.15a3.5 3.5 0 100-7 3.5 3.5 0 000 7zM300.86 51.15a3.5 3.5 0 100-7 3.5 3.5 0 000 7z",
    stroke: "#DDD",
    strokeWidth: 3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M200 173.42c39.765 0 72-3.77 72-8.42s-32.235-8.42-72-8.42-72 3.77-72 8.42 32.235 8.42 72 8.42z",
    fill: "url(#icon_no_result_svg__paint2_radial)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M223.52 140h-66c-1.66 0-3-1.34-3-3V43c0-1.66 1.34-3 3-3h46c1.66 0 3 1.34 3 3v14c0 1.66 1.34 3 3 3h14c1.66 0 3 1.34 3 3v74c0 1.66-1.34 3-3 3z",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M225.64 60.88l-.88-.88h-1.24c.77 0 1.53.29 2.12.88zM205.64 40.88c.59.59.88 1.35.88 2.12v-1.24l-.88-.88z",
    fill: "#F2F2F2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M206.52 43v14c0 1.66 1.34 3 3 3h15.24l-18.24-18.24V43z",
    fill: "#E5E5E5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M239.71 76.49c-11.15-11.15-29.23-11.15-40.37 0-11.15 11.15-11.15 29.23 0 40.37 11.15 11.14 29.23 11.15 40.37 0 11.15-11.14 11.15-29.22 0-40.37zm-5.01 35.36c-8.38 8.38-21.97 8.38-30.35 0-8.38-8.38-8.38-21.97 0-30.35 8.38-8.38 21.97-8.38 30.35 0 8.38 8.38 8.38 21.97 0 30.35z",
    fill: "#CCC"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M240.92 110.27l-7.81 7.81 19.68 19.68a3 3 0 004.24 0l3.56-3.56a3 3 0 000-4.24l-19.67-19.69z",
    fill: "#CCC"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M197.98 96.62c0 11.89 9.64 21.53 21.53 21.53 3.31 0 6.44-.77 9.25-2.11 1.47-5.45 2.58-11.86 2.58-18.86 0-7.39-1.24-14.28-2.84-20.1a21.464 21.464 0 00-8.99-1.99c-11.89 0-21.53 9.64-21.53 21.53z",
    fill: "#fff"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M219.51 118.63c12.156 0 22.01-9.854 22.01-22.01 0-12.156-9.854-22.01-22.01-22.01-12.156 0-22.01 9.854-22.01 22.01 0 12.156 9.854 22.01 22.01 22.01z",
    fill: "url(#icon_no_result_svg__paint3_radial)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "icon_no_result_svg__paint2_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(71.7934 0 0 7.44942 200.006 164.908)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.332,
    stopColor: "#DDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.901,
    stopColor: "#DDD",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "icon_no_result_svg__paint3_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-45 226.365 -216.658) scale(22.0133)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DDD",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCC",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_no_result_svg__paint0_linear",
    x1: 301.5,
    y1: 60.952,
    x2: 301.5,
    y2: 152.584,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.272,
    stopColor: "#E9E9E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.899,
    stopColor: "#E9E9E9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_no_result_svg__paint1_linear",
    x1: 92.965,
    y1: 46.641,
    x2: 92.965,
    y2: 152.217,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.272,
    stopColor: "#E9E9E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.899,
    stopColor: "#E9E9E9",
    stopOpacity: 0
  })))));
}

export default SvgIconNoResult;